// initial state
const state = {
  options: {
    status: [
      {label: '待审批', value: 1},
      {label: '通过', value: 2},
      {label: '不通过', value: 3},
    ],
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const permissionApply = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/permission-apply/permission-apply.store.js